<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import { useUserStore, useDictStore } from '@/stores/index'

const userStore = useUserStore()
const dictStore = useDictStore()

onLaunch(async (options) => {
  if (options?.query) {
    if (options?.query?.token) {
      // 存储从其他小程序传递过来的 token
      userStore.setToken(options.query.token)
      userStore.setSiteId(options.query.site_id)
    }
  }
  console.log('App Launch')
  await dictStore.refreshAllDicts()
})
onShow(() => {
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
@import 'uview-plus/theme.scss';
@import './styles/index.scss';

::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}
/* 微信小程序滚动条隐藏 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
/* 通用滚动条隐藏 */
scrollbar {
  width: 0 !important;
  -ms-overflow-style: none;
}
</style>
